import { render, staticRenderFns } from "./FAQUserIndex.vue?vue&type=template&id=d7b80226&"
import script from "./FAQUserIndex.vue?vue&type=script&lang=js&"
export * from "./FAQUserIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports